<template>
  <Modal
    @close="$emit('close')"
    title="Seleccione la escuela a gestionar"
    classes="col-lg-5"
  >
    <div class="body my-2" slot="body">
      <div v-if="selectSchool.options.length">
        <DropSelect
          v-bind="selectSchool"
          :zIndex="2"
          :text="'text'"
          @selected="onSelectedItem"
        >
        </DropSelect>
      </div>
      <div class="col text-center" v-if="!selectSchool.options.length">
        <Spinner v-if="showSpinner" />
      </div>
      <div class="row ">
        <div class="col-lg-10 mx-auto text-center mt-5">
          <button class="button primary" @click="$emit('close')">
            Aceptar
          </button>
        </div>
      </div>
    </div>
  </Modal>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import DropSelect from "@/components/DropSelect";
import Spinner from "@/components/Spinner";
import Modal from "@/components/Modal";

export default {
  name: "SchoolModal",
  components: {
    DropSelect,
    Spinner,
    Modal,
  },
  data() {
    return {
      selectSchool: {
        options: [],
        selected: undefined,
        placeholder: "Seleccione Colegio o Sede",
        supTitle: "Colegio o Sede",
        id: "sede",
        icon: "university",
        textKey: "name",
        valueKey: "id",
      },
      showSpinner: false,
    };
  },
  computed: {
    ...mapState(["reports", "userData"]),
  },
  watch: {},
  methods: {
    ...mapMutations(["setSchool", "setOwnerSchoolSelected"]),
    getUserData() {
      this.selectSchool.options = this.userData.owner_school;
    },
    onSelectedItem(data) {
      this.setOwnerSchoolSelected(data);
    },
  },
  mounted() {
    this.getUserData();
  },
};
</script>

<style lang="scss" scoped></style>
